<div *ngIf="1 == 1">
  <div
    class="p-0 w-100 d-flex align-items-center justify-content-center rounded-3"
  >
    <div
      class="card p-0 m-0 position-relative shadow-none w-100"
      style="max-width: 560px"
      [style.background-color]="transparent ? 'rgba(0,0,0,0)' : null"
      [ngClass]="fontSmaller ? '' : card_round ? card_round : 'rounded-4'"
      [ngClass]="[
        outlined ? 'border border-1' : 'border-0 ' + albums[0]?.round,
      ]"
      [ngStyle]="{
        'box-shadow': shadow ? '0px 3px 9px -5px rgba(66, 68, 90, 1)' : 'none',
      }"
      [style]="'border-color:' + border_color + '!important'"
    >
      <img [src]="emptyImage" class="card-img" alt="empty" />
      <div
        class="card-img-overlay p-0"
        [ngStyle]="!transparent ? setButtonBg : null"
        [ngClass]="fontSmaller ? '' : sec_round ? sec_round : 'rounded-3'"
      >
        <div class="position-absolute start-0 end-0">
          <div
            *ngIf="albums && albums[0]?.en"
            class="card m-0 p-0 shadow-none rounded-0"
            style="background-color: rgba(0,0,0,{{
              albums[0].opacity
            }}); max-width: 560px; backdrop-filter: blur({{ albums[0].blur }})"
          >
            <img [src]="emptyImageP0" alt="empty" class="card-img" />
            <div
              class="card-img-overlay border overflow-hidden m-0 p-0"
              [ngClass]="debug ? 'border-1 ' : 'border-0 ' + albums[0]?.round"
            >
              <ng-template [ngTemplateOutlet]="part_0"></ng-template>
            </div>
          </div>

          <div
            *ngIf="albums && albums[1]?.en"
            class="card m-0 p-0 shadow-none"
            ngClass="{{ albums[1].round }}"
            style="background-color: rgba(0,0,0,{{
              albums[1].opacity
            }}); max-width: 560px ; backdrop-filter: blur({{ albums[1].blur }})"
            [ngStyle]="setTitleBg"
          >
            <img [src]="emptyImageP1" alt="empty" class="card-img" />
            <div
              class="card-img-overlay border overflow-hidden m-0 p-0"
              [ngClass]="debug ? 'border-1' : 'border-0'"
            >
              <ng-template [ngTemplateOutlet]="part_1"></ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #part_0>
  <!-- ********the image in center*********** -->
  <div *ngIf="styleP0 == 1" class="row m-0 p-0">
    <div
      class="col-12 d-flex align-items-center justify-content-center position-absolute top-50 start-50 translate-middle"
    >
      <img
        *ngIf="image"
        [src]="image"
        class="object-fit-cover mx-auto d-block"
        [ngStyle]="{ width: widthP0 }"
      />
    </div>
  </div>

  <!-- ********the image in background*********** -->
  <div *ngIf="styleP0 == 2" class="row m-0 p-0">
    <div class="col-12 p-0 m-0">
      <img
        *ngIf="image"
        [src]="image"
        class="card-img m-0 p-0"
        class="object-fit-cover mx-auto d-block"
        [ngStyle]="{ width: widthP0 }"
      />
      <!-- <div class="card-img-overlay p-0" [ngStyle]="setImageP1" *ngIf="image"></div> -->
    </div>
  </div>
  <!-- ********the image & text togther*********** -->
  <div
    *ngIf="styleP0 == 3"
    class="row m-0 p-0 d-flex align-items-center justify-content-center"
  >
    <div
      class="col-5 m-0"
      [ngStyle]="{ padding: fontSmaller ? '0px' : albums[0].padding }"
    >
      <img
        *ngIf="image"
        [src]="image"
        class="object-fit-cover mx-auto d-block"
        [ngStyle]="{ width: widthP0 }"
      />
    </div>
    <div
      class="col-7 m-0 text-wrap mb-0"
      [ngStyle]="{ padding: fontSmaller ? '0px' : albums[0].padding }"
    >
      <p
        type="text"
        class="card-title p-0 m-0 w-100 shadow-none border-0"
        [ngStyle]="lableColor"
      >
        {{ label }}
      </p>
      <p class="p-0 m-0 text-wrap" [ngStyle]="sublableColor">
        {{ sublable }}
      </p>
    </div>
  </div>
</ng-template>

<ng-template #part_1>
  <div *ngIf="styleP1 == 1" class="row text-wrap m-0 p-0">
    <div class="col-10 offset-1 text-center p-0 mb-0">
      <p
        type="text"
        class="card-title p-0 m-0 w-100 d-flex shadow-none border-0"
        [ngClass]="
          label_align === 'center'
            ? 'justify-content-center align-items-center'
            : label_align === 'right'
              ? 'justify-content-end align-items-end'
              : 'justify-content-start align-items-start'
        "
        [ngStyle]="lableColor"
      >
        {{ label }}
      </p>
      <p
        class="p-0 m-0 text-wrap d-flex shadow-none border-0"
        [ngStyle]="sublableColor"
        [ngClass]="
          sublabel_align === 'center'
            ? 'justify-content-center align-items-center'
            : sublabel_align === 'right'
              ? 'justify-content-end align-items-end'
              : 'justify-content-start align-items-start'
        "
      >
        {{ sublable }}
      </p>
    </div>
  </div>

  <div *ngIf="styleP1 == 0" class="row text-wrap m-0 p-0">
    <div
      class="col-12 d-flex position-absolute top-50 start-50 translate-middle align-items-center"
    >
      <div class="row p-0 m-0 w-100 d-flex align-items-center">
        <div class="col-2 p-0">
          <div class="d-flex align-items-center justify-content-center rounded-2" [ngStyle]="bgPlaceHolderColor">
            <i
              class="align-middle"
              [ngStyle]="leadingIconColor"
              [class]="
                builderService.getIcon(leading_icon).type == 'mir'
                  ? 'material-icons-outlined'
                  : 'material-icons'
              "
            >
              {{ builderService.getIcon(leading_icon).id }}
            </i>
          </div>
        </div>
        <div class="col-8 p-2">
          <p class="p-0 m-0 shadow-none border-0" [ngStyle]="lableColor">
            {{ label }}
          </p>
          <p class="p-0 m-0 shadow-none border-0" [ngStyle]="sublableColor">
            {{ sublable }}
          </p>
        </div>
        <div class="col-2 d-flex justify-content-end align-items-end p-0">

            <i
              class="align-middle"
              [ngStyle]="traillingIconColor"
              [class]="
                builderService.getIcon(trailing_icon).type == 'mir'
                  ? 'material-icons-outlined'
                  : 'material-icons'
              "
            >
              {{ builderService.getIcon(trailing_icon).id }}
            </i>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="styleP1 == 2" class="row text-wrap m-0 p-0">
    <div
      class="col-12 d-flex position-absolute top-50 start-50 translate-middle align-items-center"
    >
      <div class="row p-0 m-0 w-100 d-flex align-items-center">
        <div class="col-2 p-0">
          <div class="d-flex align-items-center justify-content-center rounded-2" [ngStyle]="bgPlaceHolderColor">
            <i
              class="align-middle"
              [ngStyle]="leadingIconColor"
              [class]="
                builderService.getIcon(leading_icon).type == 'mir'
                  ? 'material-icons-outlined'
                  : 'material-icons'
              "
            >
              {{ builderService.getIcon(leading_icon).id }}
            </i>
          </div>
        </div>
        <div class="col-8 p-2">
          <p class="p-0 m-0 shadow-none border-0" [ngStyle]="lableColor">
            {{ label }}
          </p>
          <p class="p-0 m-0 shadow-none border-0" [ngStyle]="sublableColor">
            {{ sublable }}
          </p>
        </div>
        <div class="col-2 d-flex justify-content-end align-items-end p-0">

            <i
              class="align-middle"
              [ngStyle]="traillingIconColor"
              [class]="
                builderService.getIcon(trailing_icon).type == 'mir'
                  ? 'material-icons-outlined'
                  : 'material-icons'
              "
            >
              {{ builderService.getIcon(trailing_icon).id }}
            </i>
        </div>
      </div>
    </div>
  </div>
</ng-template>
